import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home.vue';
import store from '@/store/store';

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta: {
                storeCallPre: 'loadManagerData',
            },
        },
    ],
});

router.beforeEach((to, from, next) => {
    const req = {
        currentSession: store.state.session,
    };
    if (to.name === null) {
        router.push('404');
    }

    if (to.meta.storeCallPre !== undefined) {
        if (to.meta.storeCallPost !== undefined) {
            store.dispatch(to.meta.storeCallPre, req).then(() => {
                next(store.dispatch(to.meta.storeCallPost));
            });
        } else {
            store.dispatch(to.meta.storeCallPre, req).then(() => {
                next();
            });
        }
    } else if (to.meta.storeCallPost !== undefined) {
        next(store.dispatch(to.meta.storeCallPost));
    } else {
        next();
    }
});

export default router;
